const shipping = {
    free_shipping: 'Gratis Verzending',
    standard_shipping: 'Standaard Verzending',
    express_shipping: 'Express Verzending',
    free_shipping_desc: 'Voor bestellingen boven €50 - 3-5 werkdagen. Alleen beschikbaar in Nederland.',
    standard_shipping_desc: '3-5 werkdagen. Alleen beschikbaar in Nederland.',
    express_shipping_desc: '1-2 werkdagen. Alleen beschikbaar in Nederland.',
    netherlands_only: 'Alleen beschikbaar in Nederland'
};

export default shipping;

